<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />{{ userStore.user.ssn }}
            <br/>{{ userStore.user.dob }}

        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: Dispute of Late Payments on My Consumer File
        </p>
        <p class="letter-content">
            To whom it may concern,
        </p>
        <p class="letter-content">
            I am writing to formally dispute the reporting of late payments on my consumer file, specifically 
            related to the accounts below. Upon reviewing my credit report, I noticed that these late payments listed below are inaccurately reported, which is adversely effecting my creditworthiness.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            Under the Fair Credit Reporting Act:
            15 USC 1681 Section 602 guarantees my right to privacy. This ensures the confidentiality of my 
            credit report and mandates that information on it must be reported in a way that is fair and 
            accurate to protect the consumer's privacy.
        </p>
        <p class="letter-content">
            15 USC 1681 Section 604a Section 2 stipulates that a consumer reporting agency cannot furnish 
            a report containing information on a consumer's credit worthiness, credit standing, credit 
            capacity, character, general reputation, personal characteristics, or mode of living without the 
            consumer's written instructions.
        </p>

        <p class="letter-content">
            In light of these provisions, I challenge the authenticity and validity of the late payments 
            recorded on my account and request your agency to produce evidence or documentation that 
            validates this reporting in accordance with my written instructions.
        </p>
        
        <p class="letter-content">
            Moreover, in alignment with 15 USC 1666b, a creditor may not treat a payment on a credit card 
            account under an open-end consumer credit plan as late for any purpose unless they have 
            adopted reasonable procedures designed to ensure that each periodic statement contains the 
            required information. Hence, I demand proof that the said procedures were correctly adhered to 
            in my case.
        </p>
        <p class="letter-content">
            If you cannot produce the necessary documents validating these late payment entries, or if the 
            entries are found to be inaccurate, I kindly demand that they be deleted immediately or be 
            updated to reflect as "Paid on Time" or "OK".
        </p>
        <p class="letter-content">
            It is essential for credit reporting agencies to ensure that all consumer reports are accurate, and 
            any inaccuracies are dealt with in a swift manner. I trust that you will handle this matter with the 
            urgency and attention it demands.
        </p>
        <p class="letter-content">
            Please initiate an investigation into this matter immediately. According to the FCRA, you are 
            required to conduct this investigation within 30 days of receiving this letter. Upon completion, I 
            request to be informed of the outcome of your investigation and to receive an updated copy of 
            my credit report if any corrections are made.
        </p>
        <p class="letter-content">
            I thank you in advance for your cooperation and expect a prompt resolution.
        </p>
        <p>
            Kind Regards,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
